import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/all';

gsap.registerPlugin(ScrollTrigger);

export default {
  init() {

  },
  finalize() {

    // Animate in banner highlight
    const $captionHighlightedFrontWrap = $('.caption-highlighted-front-wrap');

    if ($captionHighlightedFrontWrap.length > 0) {
      const captionItem = $captionHighlightedFrontWrap.get();

      gsap.fromTo(captionItem, {
        width: 0,
      }, {
        width: '100%',
        duration: 1.2,
        delay: 0.2,
        scrollTrigger: {
          trigger: captionItem,
          start: 'top bottom',
        },
      });
    }

    // Animate in services module (desktop up only)
    if ($(window).width() >= 992) {
      const $servicesModule = $('.useful-services-bit');

      if ($servicesModule.length > 0) {
        const servicesModule = $servicesModule.get();

        gsap.fromTo(servicesModule, {
          opacity: 0,
          y: '20px',
        }, {
          opacity: 1,
          y: 0,
          duration: 0.6,
          delay: 0.5,
          scrollTrigger: {
            trigger: servicesModule,
            start: 'top bottom',
          },
        });
      }
    }

  },
}


// WEBPACK FOOTER //
// ./scripts/routes/templateHomepage.js